import React, { useEffect, useState } from 'react';

// components

import ShopByZipcodeModal from './ShopByZipcodeModal';
import GAEPList from './GAEPList';
import GAEPMainContent from './GAEPMainContent';
import ExternalSiteModal from '@components/common/modal/ExternalSiteModal';

// hooks

import useGaep, { CountyZip } from './useGaep';
import useDisclosure from '@hooks/useDisclosure';

// type

import type { SearchResultProps } from './useGaep';

// constants

const ZIPCODE_CACHE_KEY = 'ga_zipcode';
const CARRIERS_SEARCH_RESULTS_CACHE_KEY = 'ga_carriers_result';

function GAEPInsCompanyContainer() {

    const [ zipcodeToSearch, setZipcodeToSearch ] = useState<string | null>(null);
    const { data, getAllInsCompanies, searchCarriersByZipcode } = useGaep();
    const [ searchResults, setSearchResults ] = useState<SearchResultProps | null>(null);
    const { isOpen, onOpen, onClose } = useDisclosure(false);
    const { isOpen: isShowSearchByZipModal, onOpen: openSearchByZipModal, onClose: closeSearchByZipModal } = useDisclosure(false);
    const [ selectedUrl, setSelectedUrl ] = useState<string | null>(null);

    useEffect(() => {
        document.title = 'Carrier Listing';
        getAllInsCompanies();
        if (!sessionStorage?.[ZIPCODE_CACHE_KEY]) {
            openSearchByZipModal();
        } else {
            setZipcodeToSearch(sessionStorage?.[ZIPCODE_CACHE_KEY]);
        }
        if (sessionStorage?.[CARRIERS_SEARCH_RESULTS_CACHE_KEY]) {
            setSearchResults(JSON.parse(sessionStorage?.[CARRIERS_SEARCH_RESULTS_CACHE_KEY]));
        }
    }, []);

    useEffect(() => {
        if (data?.data) {
            sessionStorage[CARRIERS_SEARCH_RESULTS_CACHE_KEY] = JSON.stringify(data?.data);
        }
    }, [data]);

    const onSearchByZipcode = async (zipcode: string, countycode?: CountyZip) => {
        closeSearchByZipModal();
        setZipcodeToSearch(zipcode);
        sessionStorage.ga_zipcode = zipcode;

        // get counties for this zipcode, loop through data
        const res: SearchResultProps = await searchCarriersByZipcode(zipcode, countycode?.value);
        setSearchResults(res);
        sessionStorage.ga_carriers_result = JSON.stringify(res);
    };

    const onClickCheckAvailability = () => openSearchByZipModal();

    const onChangeZipcode = () => openSearchByZipModal();

    const onHandleClickExternalUrl = (url: string) => {
        setSelectedUrl(url);
        open();
    };

    const onHandleContinueExternalUrl = () => {
        close();
        selectedUrl && window.open(selectedUrl);
    };

    const onHandleShowAll = () => {
        getAllInsCompanies();
    };

    return (
        <>
            <GAEPMainContent titleId='gaep.ins_company.shop_with_an_ins_company' mainContentId='carriers.main_content' mainContentSecondLineId='carriers.main_content.second_line' mainContentThirdLineId='carriers.main_content.third_line' />
            <main className="usa-layout-docs usa-section gi-main-section" id="gaep-ins-company">
                <div className="grid-container gi-grid-container">
                    <GAEPList
                        data={searchResults?.data || data?.data}
                        isInsCompanyMode={true}
                        zipcode={zipcodeToSearch}
                        onChangeZipcode={onChangeZipcode}
                        onClickCheckAvailability={onClickCheckAvailability}
                        onHandleClickExternalUrl={onHandleClickExternalUrl}
                        onHandleShowAll={onHandleShowAll}
                    />
                </div>
            </main>
            {
                isShowSearchByZipModal &&
                <ShopByZipcodeModal show={isShowSearchByZipModal} counties={searchResults?.counties || data?.counties} zipcode={zipcodeToSearch} onSearch={onSearchByZipcode} onHide={ closeSearchByZipModal }/>
            }
            {
                isOpen &&
                <ExternalSiteModal messageId='gaep.external_url.message' onCancel={close} onContinue={onHandleContinueExternalUrl} />
            }
        </>
    );
}

export default GAEPInsCompanyContainer;